import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { getProfileData } from '../../../Redux/action/MasterAction';

import { BeatLoader } from 'react-spinners';
import { jwtDecode } from "jwt-decode";
import { db } from '../../firbase';
import { doc, updateDoc } from "firebase/firestore";
import axios from 'axios';

const host = process.env.REACT_APP_API_SERVER
const TutorSidebar = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const authToken = localStorage.getItem('tutor-token');
    const fetchCalled = useRef(false); // Track if fetch is already called

    const {
        ProfileDataListApiData,
        loadingProfileDataListApi,
        ProfileDataListApiError,
    } = useSelector(state => state?.MasterReducer);

    // useEffect(() => {
    //     // Fetch profile data only once during the first render
    //     if (!fetchCalled.current && authToken) {
    //         fetchCalled.current = true; // Mark as fetched
    //         if (!ProfileDataListApiData) {
    //             dispatch(getProfileData(authToken));
    //         }
    //     }
    // }, [authToken, dispatch, ProfileDataListApiData]);

    const handleLogout = async () => {
        try {
            
            axios.get(`${host}/api/web/change-online-status?status=0`, {
                headers: {
                    "x-auth-token": localStorage.getItem('tutor-token')
                }
            });
    
            localStorage.removeItem('tutor-token');

            navigate('/login', { state: { user: 'tutor' } });
        } catch (error) {
            console.error('Error while logging out:', error);
        }
    };

    return (
        <div className="sidebar-container">
            <aside id="sidebar-container">
                <nav className="navbar navbar-light">
                    <div className="container d-block">
                        <div className="profile-img-sec">
                            <img
                                src={`${host}${ProfileDataListApiData?.data?.profile_img}`}
                                className="img-fluid"
                                onError={(e) => {
                                    e.target.src = '/assets/img/user/user.png'; // Fallback image
                                }}
                            />
                            {loadingProfileDataListApi ?
                                <BeatLoader />
                                :
                                <>
                                    <h5 className="mt-3 mb-0">{ProfileDataListApiData?.data?.name}</h5>
                                    <p className="mb-0">{ProfileDataListApiData?.data?.tutordetails?.specialization} {ProfileDataListApiData?.data?.tutordetails?.qualifications ? `(${ProfileDataListApiData?.data?.tutordetails?.qualifications})` : ''}</p>
                                    <div className="mt-2 rating">
                                        {Array.from({ length: 5 }, (_, index) => { 
                                            if (index < Math.floor(ProfileDataListApiData?.avarageRating || 0)) {
                                                return <i key={index} className="fas fa-star filled" />;
                                            } else if (index < ProfileDataListApiData?.avarageRating) {
                                                return <i key={index} className="fas fa-star-half-alt filled" />;
                                            } else {
                                                return <i key={index} className="fas fa-star" />;
                                            }
                                        })}
                                    </div>
                                </>}
                        </div>
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link
                                    className={`${(pathname == '/tutor/dashboard') ? 'active nav-link' : 'nav-link'}`}
                                    aria-current="page"
                                    to="/tutor/dashboard"
                                >
                                    <i className="fa-solid fa-house-chimney" />
                                    &nbsp;Dashboard
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`${(pathname == '/tutor/my-students' || pathname == '/tutor/my-students-group') ? 'active nav-link' : 'nav-link'}`} to="/tutor/my-students">
                                    <i className="fas fa-graduation-cap" />
                                    &nbsp;My Students
                                </Link>
                            </li>
                             <li className="nav-item">
                                <Link className={`${pathname == '/tutor/study-material' ? 'active nav-link' : 'nav-link'}`} to="/tutor/study-material">
                                    <i className="fas fa-book-reader" />
                                    &nbsp;Study Materials
                                </Link>
                            </li>
                             <li className="nav-item">
                                <Link className={`${(pathname == '/tutor/my-courses' || pathname == '/tutor/add-new-group-course' || pathname == '/tutor/group-course-list' || pathname == '/tutor/booked-schedule') ? 'active nav-link' : 'nav-link'}`} to="/tutor/my-courses">
                                    <i className="fas fa-calendar-alt" />
                                    &nbsp;My Courses
                                </Link>
                            </li>
                             <li className="nav-item">
                                <Link className={`${pathname == '/tutor/my-earnings' ? 'active nav-link' : 'nav-link'}`} to="/tutor/my-earnings">
                                    <i className="fas fa-hand-holding-usd" />
                                    &nbsp;My Earnings
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`${pathname == '/tutor/browse-students' ? 'active nav-link' : 'nav-link'}`} to="/tutor/browse-students">
                                    <i className="fas fa-chalkboard-teacher" />
                                    &nbsp;Browse Students
                                </Link>
                            </li>
                             <li className="nav-item">
                                <Link className={`${(pathname == '/tutor/my-assessments-main' || pathname == '/tutor/add-objective-assessment' || pathname == '/tutor/add-subjective-assessment' || pathname == '/tutor/completed-assessment' || pathname == '/tutor/view-assessment-course') ? 'active nav-link' : 'nav-link'}`} to="/tutor/my-assessments-main">

                                    <i className="fas fa-laptop-code" />
                                    &nbsp;My Assessments
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`${pathname == '/tutor/bookings' ? 'active nav-link' : 'nav-link'}`} to="/tutor/bookings">
                                    <i className="fa fa-clock-o" />
                                    &nbsp;Booking
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`${(pathname == '/tutor/message' || pathname == '/tutor/chat') ? 'active nav-link' : 'nav-link'}`} to="/tutor/message">
                                    <i className="fa-solid fa-comments" />
                                    &nbsp;Message
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`${pathname == '/tutor/student-queries' ? 'active nav-link' : 'nav-link'}`} to="/tutor/student-queries">
                                    <i className="fa-solid fa-clipboard-question" />
                                    &nbsp;Student Queries
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`${pathname == '/tutor/contact-us' ? 'active nav-link' : 'nav-link'}`} to="/tutor/contact-us">
                                    <i className="fa-solid fa-users" />
                                    &nbsp;Contact us
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`${pathname == '/tutor/reviews' ? 'active nav-link' : 'nav-link'}`} to="/tutor/reviews">
                                    <i className="fa-solid fa-star" />
                                    &nbsp;Reviews
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`${(pathname == '/tutor/profile-settings' || pathname == '/tutor/profile-settings-personal-info' || pathname == '/tutor/profile-settings-bank-details' || pathname == '/tutor/profile-settings-updated-tutoring-price' || pathname == '/tutor/profile-settings-tutor-teaching-list' || pathname == '/tutor/profile-settings-cip') ? 'active nav-link' : 'nav-link'}`} to="/tutor/profile-settings">
                                    <i className="fa fa-user-circle-o" />
                                    &nbsp;Profile
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className="nav-link btn text-start"

                                    data-bs-toggle="modal"
                                    data-bs-target="#exampleModal"
                                >
                                    <i className="fa-solid fa-right-from-bracket" />
                                    &nbsp;Logout
                                </Link>
                            </li>
                        </ul>
                    </div>
                </nav>
            </aside>
            <div
                className="modal fade logout-modal"
                id="exampleModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div
                            className="modal-body my-4"
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <img src="/assets/img/user/okay-img.png" className="img-fluid" />
                            <h4>Log out</h4>
                            <p>Are you sure you want to log out?</p>
                            <div className="modal-footer">
                                <a onClick={handleLogout}>
                                    <button type="button" className="btn btn-primary" data-bs-dismiss="modal">
                                        Logout
                                    </button>
                                </a>
                                <Link to="">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        data-bs-dismiss="modal"
                                    >
                                        Cancel
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TutorSidebar